<template>
  <nav class="navbar navbar-expand-lg bg-white">
    <div class="container-fluid">
      <AppLogo/>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
              data-bs-target="#navbarToggle"
              aria-controls="navbarToggle" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarToggle">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <AppMenuItems/>
        </ul>
      </div>
    </div>
  </nav>
  <div class="container-fluid">
    <div class="row p-4" id="faq">
      <h1 class="text-center section p-5 fw-bold">{{ $t('faq.faqTitle') }}</h1>
      <p class="text-center">{{ $t('faq.faqSubtitle') }}</p>
      <h5 class="poppinsBold p-1 pt-4">{{ $t('faq.reservations') }}</h5>
      <div class="accordion" id="faqBookings">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOne" aria-controls="collapseOne">
              {{ $t('faq.howToBook') }}
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
               data-bs-parent="#faqBookings">
            <div class="accordion-body" v-html="$t('faq.bookingAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              {{ $t('faq.visitPossible') }}
            </button>
          </h2>
          <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
               data-bs-parent="#faqBookings">
            <div class="accordion-body" v-html="$t('faq.visitAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              {{ $t('faq.durationExtensionsCancellations') }}
            </button>
          </h2>
          <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
               data-bs-parent="#faqBookings">
            <div class="accordion-body" v-html="$t('faq.durationAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
              {{ $t('faq.checkin') }}
            </button>
          </h2>
          <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
               data-bs-parent="#faqBookings">
            <div class="accordion-body" v-html="$t('faq.checkinAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFive">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
              {{ $t('faq.inventory') }}
            </button>
          </h2>
          <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
               data-bs-parent="#faqBookings">
            <div class="accordion-body" v-html="$t('faq.inventoryAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingSix">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
              {{ $t('faq.beddingTowels') }}
            </button>
          </h2>
          <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix"
               data-bs-parent="#faqBookings">
            <div class="accordion-body" v-html="$t('faq.beddingAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingSeven">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
              {{ $t('faq.checkout') }}
            </button>
          </h2>
          <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven"
               data-bs-parent="#faqBookings">
            <div class="accordion-body" v-html="$t('faq.checkoutAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingEight">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
              {{ $t('faq.deposit') }}
            </button>
          </h2>
          <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight"
               data-bs-parent="#faqBookings">
            <div class="accordion-body" v-html="$t('faq.depositAnswer')"></div>
          </div>
        </div>
      </div>
      <h5 class="poppinsBold p-1 pt-4">{{ $t('faq.payments') }}</h5>
      <div class="accordion" id="faqPayments">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingPaymentsOne">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapsePaymentsOne"
                    aria-controls="collapsePaymentsOne">
              {{ $t('faq.howToPay') }}
            </button>
          </h2>
          <div id="collapsePaymentsOne" class="accordion-collapse collapse"
               aria-labelledby="headingPaymentsOne"
               data-bs-parent="#faqPayments">
            <div class="accordion-body" v-html="$t('faq.howToPayAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingPaymentsTwo">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapsePaymentsTwo" aria-expanded="false"
                    aria-controls="collapsePaymentsTwo">
              {{ $t('faq.includedExpenses') }}
            </button>
          </h2>
          <div id="collapsePaymentsTwo" class="accordion-collapse collapse" aria-labelledby="headingPaymentsTwo"
               data-bs-parent="#faqPayments">
            <div class="accordion-body" v-html="$t('faq.includedExpensesAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingPaymentsThree">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapsePaymentsThree" aria-expanded="false"
                    aria-controls="collapsePaymentsThree">
              {{ $t('faq.return') }}
            </button>
          </h2>
          <div id="collapsePaymentsThree" class="accordion-collapse collapse" aria-labelledby="headingPaymentsThree"
               data-bs-parent="#faqPayments">
            <div class="accordion-body" v-html="$t('faq.returnAnswer')"></div>
          </div>
        </div>
      </div>
      <h5 class="poppinsBold p-1 pt-4">{{ $t('faq.rulesBehaviour') }}</h5>
      <div class="accordion" id="faqBehaviour">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingBehaviourOne">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBehaviourOne"
                    aria-controls="collapseBehaviourOne">
              {{ $t('faq.whatRules') }}
            </button>
          </h2>
          <div id="collapseBehaviourOne" class="accordion-collapse collapse"
               aria-labelledby="headingBehaviourOne"
               data-bs-parent="#faqBehaviour">
            <div class="accordion-body" v-html="$t('faq.rulesAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingBehaviourTwo">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBehaviourTwo"
                    aria-controls="collapseBehaviourTwo">
              {{ $t('faq.doubleOccupancy') }}
            </button>
          </h2>
          <div id="collapseBehaviourTwo" class="accordion-collapse collapse"
               aria-labelledby="headingBehaviourTwo"
               data-bs-parent="#faqBehaviour">
            <div class="accordion-body" v-html="$t('faq.doubleOccupancyAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingBehaviourThree">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBehaviourThree"
                    aria-controls="collapseBehaviourThree">
              {{ $t('faq.residentsProfile') }}
            </button>
          </h2>
          <div id="collapseBehaviourThree" class="accordion-collapse collapse"
               aria-labelledby="headingBehaviourThree"
               data-bs-parent="#faqBehaviour">
            <div class="accordion-body" v-html="$t('faq.residentsProfileAnswer')"></div>
          </div>
        </div>
      </div>
      <h5 class="poppinsBold p-1 pt-4">{{ $t('faq.maintenanceProblems') }}</h5>
      <div class="accordion" id="faqIssues">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingIssuesOne">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseIssuesOne"
                    aria-controls="collapseIssuesOne">
              {{ $t('faq.whatToDoIfSomethingFails') }}
            </button>
          </h2>
          <div id="collapseIssuesOne" class="accordion-collapse collapse"
               aria-labelledby="headingIssuesOne"
               data-bs-parent="#faqIssues">
            <div class="accordion-body" v-html="$t('faq.whatToDoIfSomethingFailsAnswer')"></div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingIssuesTwo">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseIssuesTwo"
                    aria-controls="collapseIssuesTwo">
              {{ $t('faq.whatToDoEmergency') }}
            </button>
          </h2>
          <div id="collapseIssuesTwo" class="accordion-collapse collapse"
               aria-labelledby="headingIssuesTwo"
               data-bs-parent="#faqIssues">
            <div class="accordion-body" v-html="$t('faq.whatToDoEmergencyAnswer')"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <AppFooter/>
</template>

<script>
import AppFooter from "@/components/Footer.vue";
import AppMenuItems from "@/components/MenuItems.vue";
import AppLogo from "@/components/Logo.vue";

export default {
  name: 'AppFaq',
  components: {AppLogo, AppMenuItems, AppFooter},
  el: '#app',
  data() {
    return {}
  },
  mounted() {
    document.title = this.generateTitle();

    this.setMeta();
  },
  methods: {
    generateMessageMeta: function () {
      if (this.es) {
        return "Resuelve tus dudas sobre el alquiler de pisos (https://flatprive.com/alquiler-piso-leon) y habitaciones en León (https://flatprive.com/alquiler-habitacion-leon). Flatprive responde las preguntas más frecuentes.";
      } else {
        return "Resolve your doubts about renting apartments (https://flatprive.com/en/apartment-rental-leon) and rooms (https://flatprive.com/en/room-rental-leon) in León. Flatprive answers the most frequently asked questions.";
      }
    },
    setMeta: function () {
      let message = this.generateMessageMeta();
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", message);
      } else {
        const meta = document.createElement('meta');
        meta.name = "description";
        meta.content = message;
        document.head.appendChild(meta);
      }
    },
    generateTitle: function () {
      return this.es ? 'Preguntas Frecuentes | Flatprive' : 'FAQ | Flatprive';
    }
  }
}
</script>

<style scoped src="../assets/css/find.css"></style>
<style scoped>
:deep(.nav-link) {
  color: #264464 !important;
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 400;
}
</style>